const ContactCta = () => {
    return <>
        <a href="/contact" class="cta-button-link w-inline-block"><img src="../img/get-in-touch.svg" alt="Circle Text — Craftco Template" class="circle-text" />
            <div class="cta-arrow">keyboard_return</div>
            <div class="circle-button"></div>
        </a>
    </>
}

export default ContactCta